/* eslint-disable import/no-named-default,@typescript-eslint/no-explicit-any */
import {
    default as ActiveNoMessageIcon,
    default as SelectedActiveNoMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Active-No-Message.png';
import {
    default as OutOfServiceNoMessageIcon,
    default as SelectedOutOfServiceNoMessageIcon
} from 'Resources/Images/DmsIcons/DMS-OOS-No-Message.png';
import {
    default as ErrorNoMessageIcon,
    default as SelectedErrorNoMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Error-No-Message.png';
import {
    default as FailedNoMessageIcon,
    default as SelectedFailedNoMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Failed-No-Message.png';
import {
    default as ActiveMessageIcon,
    default as SelectedActiveMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Active-Message.png';
import {
    default as OutOfServiceMessageIcon,
    default as SelectedOutOfServiceMessageIcon
} from 'Resources/Images/DmsIcons/DMS-OOS-Message.png';
import {
    default as ErrorMessageIcon,
    default as SelectedErrorMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Error-Message.png';
import {
    default as FailedMessageIcon,
    default as SelectedFailedMessageIcon
} from 'Resources/Images/DmsIcons/DMS-Failed-Message.png';
import { OpStatus } from 'NSwag/ServerClient/Client.nswag';

interface IOptions {
    unselectedNoMessage: any;
    unselectedMessage: any;
    selectedNoMessage: any;
    selectedMessage: any;
}

type IIconMap = Map<OpStatus, IOptions>;

/**
 * Maps all OpStatus enum values to their associated icon.
 */
const iconMapping: IIconMap = new Map<OpStatus, IOptions>([
    [OpStatus.NULL, {
        unselectedNoMessage: OutOfServiceNoMessageIcon,
        unselectedMessage: OutOfServiceMessageIcon,
        selectedNoMessage: SelectedOutOfServiceNoMessageIcon,
        selectedMessage: SelectedOutOfServiceMessageIcon
    }],
    [OpStatus.NotSet, {
        unselectedNoMessage: OutOfServiceNoMessageIcon,
        unselectedMessage: OutOfServiceMessageIcon,
        selectedNoMessage: SelectedOutOfServiceNoMessageIcon,
        selectedMessage: SelectedOutOfServiceMessageIcon
    }],
    [OpStatus.Active, {
        unselectedNoMessage: ActiveNoMessageIcon,
        unselectedMessage: ActiveMessageIcon,
        selectedNoMessage: SelectedActiveNoMessageIcon,
        selectedMessage: SelectedActiveMessageIcon
    }],
    [OpStatus.Error, {
        unselectedNoMessage: ErrorNoMessageIcon,
        unselectedMessage: ErrorMessageIcon,
        selectedNoMessage: SelectedErrorNoMessageIcon,
        selectedMessage: SelectedErrorMessageIcon
    }],
    [OpStatus.Failed, {
        unselectedNoMessage: FailedNoMessageIcon,
        unselectedMessage: FailedMessageIcon,
        selectedNoMessage: SelectedFailedNoMessageIcon,
        selectedMessage: SelectedFailedMessageIcon
    }],
    [OpStatus.OutOfService, {
        unselectedNoMessage: OutOfServiceNoMessageIcon,
        unselectedMessage: OutOfServiceMessageIcon,
        selectedNoMessage: SelectedOutOfServiceNoMessageIcon,
        selectedMessage: SelectedOutOfServiceMessageIcon
    }]
]);

const ContainsPrintableCharacters = (message: string): boolean => {
    const regex = /(\[.+?]|\s)/gm;
    return message.replace(regex, '') !== '';
};

/**
 * Takes in an OpStatus for a detector and returns the associated icon
 * @param opStatus - Current status of the DMS
 * @param msgText - MultiMessage on the DMS
 * @param selected - True if the DMS is currently selected, defaults to false
 */
export const getDmsIcon = (opStatus: OpStatus, msgText = '', selected = false): string => {
    let icons = iconMapping.get(opStatus);

    if (icons == null) {
        icons = iconMapping.get(OpStatus.NULL);
    }

    if (icons == null) {
        return '';
    }

    const hasMessage = ContainsPrintableCharacters(msgText);

    return hasMessage
        ? selected ? icons.selectedMessage : icons.unselectedMessage
        : selected ? icons.selectedNoMessage : icons.unselectedNoMessage;
};
